// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container{
   display: flex;
   padding: 10px;
   padding-left: 10px;
   padding-right: 10px;

}

.welcome-section {
   width: 100%; 
   display: flex;
   align-items: center ;
   justify-content: space-between;
}

.welcome-section h1{
   padding: 20px;
   font-size: 23px;
   color: #333;
   text-align: center;
}

.content-image{
   height:54vh;
   width: 80%;
   display: block; 
   flex: 0;
   object-fit: cover;
}

.sidebar{
    padding-left: 20px;
    padding-bottom: 10px; 
   
}

.sidebar-section{
   margin-bottom: 0px;
     
}
.sidebar  h3 {
   
   color: white;
   background-color:#286090;
   cursor: pointer;
   padding-top: 4px; 
   padding-bottom: 4px;
   font-family: Arial, sans-serif;
   padding-left: 10px;
   font-size: 20px;
   border-radius: 3px 3px 0 0;
   margin-bottom: 0px; 
   text-align: left;
}

.sidebar ul {
   border: solid 2px #286090;
   background-color:white; 
   border-radius:0 0 3px 3px ;
   list-style-type:none ;
   padding: 0;
   margin: 0;
}


.sidebar ul li {
   padding-left: 10px;
   margin-bottom: 0px;

}

.sidebar ul li a {
   text-align: left; 
   margin-bottom: 5px; 
   text-decoration: none;
   font-size: 16px;
   color: #333;
   position: relative;
   right:10px;
}

.point-list li {
   list-style-type: none; 
   margin-left: 20px; 
   position: relative;
   margin-top: 10px; 
}

.point-list li::before {
   content: '>';
   position: absolute;
   left: -15px;

   color:  #286090;
   font-weight: bolder;
   font-size: 1.2em;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/delegationofauthority/delegationofauthority.component.css"],"names":[],"mappings":"AAAA;GACG,aAAa;GACb,aAAa;GACb,kBAAkB;GAClB,mBAAmB;;AAEtB;;AAEA;GACG,WAAW;GACX,aAAa;GACb,oBAAoB;GACpB,8BAA8B;AACjC;;AAEA;GACG,aAAa;GACb,eAAe;GACf,WAAW;GACX,kBAAkB;AACrB;;AAEA;GACG,WAAW;GACX,UAAU;GACV,cAAc;GACd,OAAO;GACP,iBAAiB;AACpB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;;AAExB;;AAEA;GACG,kBAAkB;;AAErB;AACA;;GAEG,YAAY;GACZ,wBAAwB;GACxB,eAAe;GACf,gBAAgB;GAChB,mBAAmB;GACnB,8BAA8B;GAC9B,kBAAkB;GAClB,eAAe;GACf,0BAA0B;GAC1B,kBAAkB;GAClB,gBAAgB;AACnB;;AAEA;GACG,yBAAyB;GACzB,sBAAsB;GACtB,0BAA0B;GAC1B,qBAAqB;GACrB,UAAU;GACV,SAAS;AACZ;;;AAGA;GACG,kBAAkB;GAClB,kBAAkB;;AAErB;;AAEA;GACG,gBAAgB;GAChB,kBAAkB;GAClB,qBAAqB;GACrB,eAAe;GACf,WAAW;GACX,kBAAkB;GAClB,UAAU;AACb;;AAEA;GACG,qBAAqB;GACrB,iBAAiB;GACjB,kBAAkB;GAClB,gBAAgB;AACnB;;AAEA;GACG,YAAY;GACZ,kBAAkB;GAClB,WAAW;;GAEX,eAAe;GACf,mBAAmB;GACnB,gBAAgB;AACnB","sourcesContent":[".container{\n   display: flex;\n   padding: 10px;\n   padding-left: 10px;\n   padding-right: 10px;\n\n}\n\n.welcome-section {\n   width: 100%; \n   display: flex;\n   align-items: center ;\n   justify-content: space-between;\n}\n\n.welcome-section h1{\n   padding: 20px;\n   font-size: 23px;\n   color: #333;\n   text-align: center;\n}\n\n.content-image{\n   height:54vh;\n   width: 80%;\n   display: block; \n   flex: 0;\n   object-fit: cover;\n}\n\n.sidebar{\n    padding-left: 20px;\n    padding-bottom: 10px; \n   \n}\n\n.sidebar-section{\n   margin-bottom: 0px;\n     \n}\n.sidebar  h3 {\n   \n   color: white;\n   background-color:#286090;\n   cursor: pointer;\n   padding-top: 4px; \n   padding-bottom: 4px;\n   font-family: Arial, sans-serif;\n   padding-left: 10px;\n   font-size: 20px;\n   border-radius: 3px 3px 0 0;\n   margin-bottom: 0px; \n   text-align: left;\n}\n\n.sidebar ul {\n   border: solid 2px #286090;\n   background-color:white; \n   border-radius:0 0 3px 3px ;\n   list-style-type:none ;\n   padding: 0;\n   margin: 0;\n}\n\n\n.sidebar ul li {\n   padding-left: 10px;\n   margin-bottom: 0px;\n\n}\n\n.sidebar ul li a {\n   text-align: left; \n   margin-bottom: 5px; \n   text-decoration: none;\n   font-size: 16px;\n   color: #333;\n   position: relative;\n   right:10px;\n}\n\n.point-list li {\n   list-style-type: none; \n   margin-left: 20px; \n   position: relative;\n   margin-top: 10px; \n}\n\n.point-list li::before {\n   content: '>';\n   position: absolute;\n   left: -15px;\n\n   color:  #286090;\n   font-weight: bolder;\n   font-size: 1.2em;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
